import { Link as RouterLink } from 'react-router-dom';

// project imports
import { Routes } from 'utils/constants';
import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { selectTenant } from 'features/account/accountSelectors';
import Logo from './Logo';

// material-ui
import { Link } from '@mui/material';
import { setActiveItem } from 'features/app/appSlice';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const tenant = useAppSelector(selectTenant);
  const dispatch = useAppDispatch();

  return (
    <Link
      onClick={() => dispatch(setActiveItem([]))}
      component={RouterLink}
      to={`${Routes.BASE_PATH}${tenant}`}
    >
      <Logo />
    </Link>
  );
};

export default LogoSection;
